export default __webpack_public_path__ + "static/media/Winter_19.381f3362.png";